export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/comment/icon-creator-light-1be6e70a3492a2b592c2de6611970b8c.svg";